// Libs
import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import getCaretCoordinates from 'textarea-caret'

// CSS
import "./styles.scss"

// Containers/Components
import MessageBoxTag from './components/MessageBoxTag'
import Attention from '../../components/Attention'

// Normalize
import * as normalize from '../../constants/normalize'

class MessageBox extends Component {
  state = {
    tag: {
      visible: false,
      text: '',
      index: 0,
      position: []
    }
  }

  changeMessage = e => {
    const { input } = this.props
    const { tag } = this.state
    const coordinates = getCaretCoordinates(e.target, e.target.selectionEnd)
    let value = e.target.value

    // Normalize value to currency
    if (value.match(/R\$(.\S*)/) !== null) {
      const match = value.match(/R\$(.\S*)/)[1]
      const norm = normalize.currency(match)
      value = value.replace(/R\$(.\S*)/, 'R$ ' + norm)
    }

    // Open MessageBoxTag
    if (value.match(/#/) !== null) {
      const text = value.match(/#(.\S*)/)

      this.setState({
        tag: {
          ...tag,
          text: text ? text[1] : '',
          visible: true,
          position: [coordinates.top, coordinates.left]
        }
      })
    } else {
      this.setState({
        tag: {
          ...tag,
          visible: false
        }
      })
    }

    input.onChange(value)
  }

  selectTag = value => {
    const { input } = this.props
    const { tag } = this.state
    const { textarea } = this

    // Keep textarea focused
    textarea.focus()

    // Delete # trigger
    const message = input.value.replace(/#/, '')

    this.setState({
      tag: {
        ...tag,
        index: 0,
        visible: false
      }
    })

    input.onChange(message + value)
  }

  render() {
    const {
      user,
      input, meta: { touched, error },
      label,
      placeholder,
      options,
      gutter } = this.props
    const { tag: { visible, text, index, position } } = this.state
    const { changeMessage, selectTag } = this

    const messageBoxStyle = {
      margin: `${gutter / 2}px 0px`,
    }

    const messageBoxClassName = classNames(
      'message-box__textarea',
      {
        'message-box__textarea--error': touched && error,
      }
    )

    return (
      <div style={messageBoxStyle} className="message-box">
        <div className="message-box__box">
          <textarea
            {...input}
            ref={textarea => { this.textarea = textarea }}
            onChange={changeMessage}
            placeholder={placeholder}
            className={messageBoxClassName} />
          {/*
            <MessageBoxTag
              visible={visible}
              text={text}
              index={index}
              position={position}
              options={[
                ...options,
                {'tag': 'grupo', 'help': 'seu grupo', 'value': user.group},
                {'tag': 'eu', 'help': 'seu nome', 'value': user.name},
              ]}
              onClick={selectTag}/>
            */}
        </div>
      </div>
    )
  }
}

MessageBox = connect(
  state => {
    return {
      user: state.auth.user,
    }
  },
  {})(MessageBox)

export default MessageBox
